import React, { useState } from 'react';
import { useEffect } from 'react';
import { notification } from 'antd';
import api from '@/utils/api'
import { Settings } from '@/components/settings';

const getWpApiUrl = () => {
  const { pathname } = window.location;
  const wpAdminIndex = pathname.indexOf('/wp-admin');
  let rootUrl = '/'
  if (wpAdminIndex !== -1) {
    rootUrl = pathname.substring(0, wpAdminIndex);
  } else {
    rootUrl = pathname
  }
  return `${rootUrl}/wp-json/mragain-plugin/v1`;
};

async function fetchSettings() {
  const url = getWpApiUrl();
  try {
    const res = await api.get(`${url}/settings`, {}, {
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': window.myPluginSettings.nonce,
      }
    })
    return res
  } catch (error) {
    notification.error({
      message: error,
    });
  }
}

async function updateSettings(settings) {
  const data = JSON.stringify(settings)
  const url = getWpApiUrl();

  try {
    await api.post(`${url}/settings`, data, {
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': window.myPluginSettings.nonce,
      }
    })
    notification.success({ 'message': 'Settings updated successfully!' })
  } catch (error) {
    notification.error({
      message: error,
    });
  }
}

function WPSettingsPage(props) {
  const [settings, setSettings] = useState(props?.settings)

  useEffect(() => {
    console.log('WP settings', props?.settings)
    async function loadData() {
      const data = await fetchSettings();
      setSettings(data)
      console.log(data)
    }
    loadData()
  }, []);


  return (
    <Settings settings={settings}
      onSave={updateSettings} />
  );
}

export default WPSettingsPage;


